import React, { useState, useEffect } from 'react';
import styles from '../../App.module.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import api from '../../api/axios';
import { isAuthenticated, permissionConfig } from '../../index';

function Signin() {
  const slides = [{ src: '/banner/banner2wp.webp', link: 'https://www.exemplo1.com' }];

  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const [userEmail, setUserEmail] = useState("");
  const [userSenha, setUserSenha] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  async function handleSignin() {
    if (!userEmail || !userSenha) {
      setError("Preencha todos os campos");
      return;
    }

    try {
      setIsLoading(true);
      setError("");
      // NotificationManager.info("Verificando credenciais...", "Aguarde", 2000);

      const res = await api.post('/validarLogin', {
        userLogin: userEmail,
        userSenha: userSenha,
      });

      if (res.data?.token) {
        localStorage.setItem('authToken', res.data.token);

        try {
          console.log("Avisando a extensão sobre o novo token de autenticação...");
          window.postMessage({
            __GSCRM_AUTH__: true,
            type: "PAGE_TO_EXT_SAVE_TOKEN",
            token: res.data.token,
            // se quiser enviar como "authTokens" multi-empresas:
            // authTokens: { [window.location.origin + "/validarLogin"]: res.data.token }
          }, "*");
        } catch (e) {
          console.warn("Não foi possível avisar a extensão:", e);
        }

        const { userPermission } = isAuthenticated();
        const permission = userPermission || 0;
        const firstPath = permissionConfig[permission][0];
        window.location.href = firstPath;
      } else {
        setError("Login ou senha incorretos");
        NotificationManager.error("Login ou senha incorretos");
      }
    } catch (err) {
      console.error('Erro ao tentar fazer login:', err);
      setError("Erro ao tentar fazer login. erro na requisição de validação do Login, entre em contato com o programador");
      NotificationManager.error("Falha na conexão ou no servidor");
    } finally {
      setIsLoading(false);
    }
  }

  // Enter para enviar
  function onKeyDown(e) {
    if (e.key === 'Enter' && !isLoading) handleSignin();
  }

  return (
    <div>
      <NotificationContainer />
      <div className={styles.container}>
        <div style={{ minHeight: "80vh", alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "column", width: "100%" }}>
          {/* Barra de progresso fina opcional */}
          {isLoading && <div className={styles.topProgress} aria-hidden="true" />}

          <div className={styles.label}>
            <h1>LOGIN</h1>
            <p>Insira o seu email e senha para continuar</p>
          </div>

          <div className={styles.content} aria-busy={isLoading} aria-live="polite">
            <input
              className={styles.input}
              type="email"
              placeholder="Digite seu E-mail"
              value={userEmail}
              onChange={(e) => { setUserEmail(e.target.value); setError(""); }}
              onKeyDown={onKeyDown}
              disabled={isLoading}
            />
            <input
              className={styles.input}
              type="password"
              placeholder="Digite sua Senha"
              value={userSenha}
              onChange={(e) => { setUserSenha(e.target.value); setError(""); }}
              onKeyDown={onKeyDown}
              disabled={isLoading}
            />

            <div className={styles.labelError}>{error}</div>

            <button
              className={`${styles.button} ${isLoading ? styles.buttonLoading : ""}`}
              onClick={handleSignin}
              disabled={isLoading}
              aria-busy={isLoading}
            >
              {isLoading ? (
                <>
                  <span className={styles.spinner} aria-hidden="true" /> Verificando...
                </>
              ) : (
                "Entrar"
              )}
            </button>

            <div className={styles.labelsignup}>
              Não tem uma conta?
              <div className={styles.strong}>
                <a href="/signup">&nbsp;Registre-se</a>
              </div>
            </div>
          </div>
        </div>

        {/* Slider comentado */}
        {/* <div className={styles.sliderContainer}>
          <a target="_blank" rel="noopener noreferrer">
            <img
              src={slides[currentIndex].src}
              alt={`Slide ${currentIndex + 1}`}
              className={styles.sliderImage}
            />
          </a>
        </div> */}
      </div>
    </div>
  );
}

export default Signin;
